
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(1 1)"}},[_c('path',{attrs:{"fill":"#E4E8F8","fill-rule":"nonzero","d":"M.1 3.868h3.272l-.26.869zM15.273 20.543a5.272 5.272 0 0 1-5.27-5.27v1.549a5.282 5.282 0 0 0 2.493 4.469c.297.184.373.319.379.46a.341.341 0 0 1-.38.343H.1v1.809H17.95v-4.09a5.264 5.264 0 0 1-2.677.73z"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M17.95 19.81v4.09H.1V3.869L3.867.099H17.95v9.52"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M3.868.1v3.768H.099M2.678 6.05h3.57v3.57h-3.57z"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M3.67 7.835l.594.595.992-.992M2.678 11.207h3.57v3.57h-3.57z"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M3.67 12.992l.594.595.992-.992M2.678 16.364h3.57v3.57h-3.57z"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M3.67 18.149l.594.595.992-.992M11.016 8.628H8.033M15.372 7.041H8.033M10.207 13.785H8.033M10.992 12.198H8.033M15.372 12.198h-3.273M10.431 18.942H8.033M10.431 17.355H8.033M15.372 17.355h-4M11.107 13.785h1.686"}}),_c('circle',{attrs:{"cx":"15.273","cy":"15.273","r":"5.27","stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M19.038 20.31l1.273-1.273 3.591 3.59-1.274 1.274zM18.573 19.384l.694.695M19.384 18.573l.695.694"}})])])
          )
        }
      }
    